var CommResults = React.createClass({
  propTypes: {
    searchResults: React.PropTypes.object.isRequired,
    filterData: React.PropTypes.object.isRequired,
    eventHandler: React.PropTypes.func.isRequired
  },
  pageClicked(num) {
    this.props.eventHandler({actionType: 'pageClicked', num: num});
  },
  sortChanged(sortKey, index) {
    this.props.eventHandler({actionType: 'sortChanged', sortKey: sortKey});
  },
  answerStatusChanged(statusCode) {
    this.props.eventHandler({actionType: 'answerStatusChanged', statusCode: statusCode});
  },
  communityChanged(commID) {
    this.props.eventHandler({actionType: 'communityChanged', communityID: commID});
  },
  topicChanged(topicID) {
    this.props.eventHandler({actionType: 'topicChanged', topicID: topicID});
  },
  tagsChanged(tagIDs) {
    this.props.eventHandler({actionType:'tagsChanged', tagIDs: tagIDs});
  },
  dateChanged(startDate, endDate) {
    this.props.eventHandler({actionType: 'dateChanged', startDate: startDate,
      endDate: endDate });
  },
  resetFiltersClicked() {
    this.props.eventHandler({actionType: 'resetFilters'});
  },
  findSelectedSortIndex() {
    let {
      searchResults,
      filterData
    } = this.props;
    let querySortBy = searchResults.query.sortBy.toLowerCase();
    let queryDescending = searchResults.query.sortDescending;

    for (let i = 0; i < filterData.sortKeys.length; i++) {
      let sortKey = filterData.sortKeys[i];
      let thisSortBy = sortKey.key.toLowerCase();
      let thisDescending = sortKey.descending;

      if (thisDescending == undefined) thisDescending = true;

      if (thisSortBy == querySortBy && thisDescending == queryDescending) {
        return i;
      }
    }

    return 0;
  },
  paramToArray(paramName) {
    let val = RA.CommunitySearch.query[paramName];
    return typeof val == "string" ? val.split(";") : [];
  },
  paramToNumberArray(paramName) {
    return this.paramToArray(paramName).map(val => Number(val));
  },
  getPager() {
    let searchResults = this.props.searchResults;
    let pagerDetail = searchResults.pagerDetail;

    return searchResults.totalHits > 0 && pagerDetail.totalPages > 1 ?
          <ResultsPager pagerDetail={pagerDetail} onPageClicked={this.pageClicked} /> : null;
  },
  getResultsSection() {
    let {filterData, searchResults} = this.props;
	let didYouMean = searchResults.didyoumean;

    return (
      <div>
        <div className="result-col__head clearfix">
          <ResultCountSummary totalHits={searchResults.totalHits}
            pageStart={searchResults.pagerDetail.pageStart}
            pageEnd={searchResults.pagerDetail.pageEnd} />
          <ResultSort sortKeys={filterData.sortKeys}
            selectedIndex={this.findSelectedSortIndex()}
            onSortChanged={this.sortChanged} />
        </div>
	<CommDidYouMean didYouMean={didYouMean}/>
        <CommResultsList hits={searchResults.results} />
        {this.getPager()}
      </div>
    )
  },
  render() {
    let searchResults = this.props.searchResults;
	let didYouMean = searchResults.didyoumean;

    if (searchResults.totalHits == 0 && !RA.CommunitySearch.isFilterApplied()) {
		return (
			<div>
				<NoResults />
				<KBDidYouMean didYouMean={didYouMean}/>
			</div>
		)
    }

    let resultsContent = searchResults.totalHits == 0 ?
      <NoResults showResetFilters={true}
        onFilterResetClicked={this.resetFiltersClicked} /> : this.getResultsSection();

	let noResultDymSection = searchResults.totalHits == 0 ?
		<KBDidYouMean didYouMean={didYouMean}/> : '';

    return (
      <div className="row">
        <ResponsiveFilterColumn className="col-xs-12 col-sm-3 filter-col">
          <AnswerStatusFilter onStatusChanged={this.answerStatusChanged}
            selectedStatusCode={RA.CommunitySearch.query.answered} />
          <CommTopicFilter communities={searchResults.communities}
            topics={searchResults.topics}
            selectedCommunityID={RA.CommunitySearch.query.communityID}
            selectedTopicID={RA.CommunitySearch.query.topicID}
            onCommunityChanged={this.communityChanged}
            onTopicChanged={this.topicChanged} />
          <TagFilter tags={searchResults.tags}
            selectedTagIDs={this.paramToNumberArray("tags")}
            onTagsChanged={this.tagsChanged} />
          <DateFilter searchDates={this.props.filterData.searchDates}
            selectedStartDate={RA.CommunitySearch.query.beginLastModDate}
            onDateChanged={this.dateChanged} />
        </ResponsiveFilterColumn>
        <section className="col-xs-12 col-sm-9 result-col">
          {resultsContent}
		  {noResultDymSection}
        </section>
      </div>
    )
  }
});